module.exports = __webpack_public_path__ + "static/img/battery_256.3663dab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/battery_256.png
// module id = FwVB
// module chunks = 0